import React from "react";
import axios from "axios";
import {
    Alert,
    Button
} from "react-bootstrap";
import PropTypes from "prop-types";
import {
    sortableContainer,
    sortableElement
} from "react-sortable-hoc";
import arrayMove from "array-move";

import ShopsContext from "../../../context/ShopsContext";
import Loading from "../../../components/Loading";
import CollectionAddProductModal from "./modal/CollectionAddProductModal";
import CollectionRemoveProductModal from "./modal/CollectionRemoveProductModal";
import ProductListItemCard from "../../../components/ProductListItemCard";

const SortableItem = sortableElement(({children}) => (
    <div>{children}</div>
));

const SortableContainer = sortableContainer(({children}) => (
    <div>{children}</div>
));

class CollectionDetailProducts extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            products: null,
            error: null,
            success: null,
            savingError: null,
            changedOrder: false,
            savingOrder: false,

            showAddProductModal: false,
            showRemoveProductModal: false,
            removeProductModalProduct: null
        }
        this.setCollectionProductsOrder = this.setCollectionProductsOrder.bind(this);
        this.onSortEnd = this.onSortEnd.bind(this);
        this.onRemoveProduct = this.onRemoveProduct.bind(this);
    }

    componentDidMount() {
        if(this.props.collection) {
            this.setProducts(this.props.collection);
        }
    }

    // eslint-disable-next-line no-unused-vars
    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevProps.collection !== this.props.collection) {
            this.setProducts(this.props.collection);
        }
    }

    setProducts(collection) {
        this.setState({
            products: collection.products
        });
    }

    setCollectionProductsOrder() {
        this.setState({ savingOrder: true, savingError: null, success: null });
        const productOrder = this.state.products.map((product) => product.id).join(",");
        axios.post("/setCollectionProductsOrder", { shopId: this.context.currentShop.id, collectionId: this.props.collection.id, productOrder })
            .then((response) => {
                if(response.data.valid) {
                    this.setProducts(this.props.collection);
                    this.props.setCollection(response.data.collection);
                    this.setState({ changedOrder: false, success: "Product volgorde opgeslagen." });
                } else {
                    this.setState({ savingError: "Er ging iets fout. Probeer het later opnieuw. (" + response.data.error + ")" });
                }
            })
            .catch(() => {
                this.setState({ savingError: "Er ging iets fout. Probeer het later opnieuw." });
            })
            .finally(() => {
                this.setState({ savingOrder: false });
            });
    }

    onRemoveProduct(product) {
        this.setState({ showRemoveProductModal: true, removeProductModalProduct: product });
    }

    onSortEnd({oldIndex, newIndex}) {
        this.setState(({ products }) => {
            return { products: arrayMove(products, oldIndex, newIndex), changedOrder: true }
        });
    }

    render() {
        if(this.state.error) {
            return (
                <Alert variant="danger">{ this.state.error }</Alert>
            )
        }
        if(!this.state.products) {
            return (
                <Loading/>
            )
        }
        return (
            <React.Fragment>
                <CollectionAddProductModal
                    show={ this.state.showAddProductModal }
                    handleClose={ () => { this.setState({ showAddProductModal: false }) } }
                    existingProducts={ this.state.products }
                    collection={ this.props.collection }
                    setCollection={ this.props.setCollection }
                />
                <CollectionRemoveProductModal
                    show={ this.state.showRemoveProductModal }
                    handleClose={ () => { this.setState({ showRemoveProductModal: false }) } }
                    product={ this.state.removeProductModalProduct }
                    collection={ this.props.collection }
                    setCollection={ this.props.setCollection }
                />
                { this.state.products.length === 0 ? (
                    <div className="text-center">
                        <h1><i className="fas fa-shopping-basket"/></h1>
                        <h4>Geen producten</h4>
                        <p>Deze collectie heeft nog geen producten.</p>
                        <Button variant="primary" onClick={ () => { this.setState({ showAddProductModal: true }) } }>
                            <i className="fas fa-plus mr-2"/>
                            Eerste product toevoegen
                        </Button>
                    </div>
                ) : (
                    <React.Fragment>
                        { this.state.success && (
                            <Alert variant="success">{ this.state.success }</Alert>
                        )}
                        { this.state.savingError && (
                            <Alert variant="danger">{ this.state.savingError }</Alert>
                        )}
                        <Button variant="primary" className="mb-2 mr-2" onClick={ this.setCollectionProductsOrder } disabled={ this.state.savingOrder || !this.state.changedOrder }>
                            <i className="fas fa-save mr-2"/>
                            Volgorde opslaan
                        </Button>
                        <Button variant="secondary" className="mb-2 mr-2" onClick={ () => { this.setState({ showAddProductModal: true }) } } disabled={ this.state.savingOrder }>
                            <i className="fas fa-plus mr-2"/>
                            Product toevoegen
                        </Button>
                        <SortableContainer onSortEnd={ this.onSortEnd }>
                            { this.state.products.map((product, index) => (
                                <SortableItem key={ product.id } index={ index } disabled={ this.state.savingOrder }>
                                    <div className="mb-2" style={{ cursor: "grab" }}>
                                        <ProductListItemCard
                                            product={ product }
                                            onClickRemove={ this.onRemoveProduct }
                                        />
                                    </div>
                                </SortableItem>
                            ))}
                        </SortableContainer>
                    </React.Fragment>
                )}
            </React.Fragment>
        )
    }
}
CollectionDetailProducts.contextType = ShopsContext;
CollectionDetailProducts.propTypes = {
    collection: PropTypes.object,
    setCollection: PropTypes.func
}

export default CollectionDetailProducts;
